import React from "react"
import pictureModals from "stores/pictureModals"
import { useList } from "effector-react"
import PictureModal, { IPictureModalProps } from "components/PictureModal/PictureModal"
import useLocationChange from "hooks/useLocationChange"

const PictureModals = () => {
    useLocationChange(pictureModals.clear)

    async function handleClose(props: IPictureModalProps) {
        if (typeof props.onClose === "function") {
            await props.onClose()
        }
        pictureModals.hide(props)
    }

    return useList(pictureModals.list, (props: IPictureModalProps, idx) => (
        <PictureModal
            {...props}
            onClose={() => handleClose(props)}
            key={idx} />
    ))
}

export default PictureModals
